
import { CMSMenuItemViewModel } from './cms-menu-item.viewModel';

import type { ICMSContentViewModel } from '../../../types/cms-content.viewModel';
import type { CMSMenu } from '@/src/cms/domain/models/cms-menu';


export class CMSMenuViewModel implements ICMSContentViewModel {
  readonly $type = 'menu';
  langcode: string;

  items: CMSMenuItemViewModel[];

  constructor(data: { langcode: string; items: CMSMenuItemViewModel[] }) {
    this.langcode = data.langcode;
    this.items = data.items.map((item) => new CMSMenuItemViewModel(item));
  }

  static presenter(entity: CMSMenu): CMSMenuViewModel {
    return new CMSMenuViewModel({
      langcode: entity.langcode,
      items: entity.items.map(CMSMenuItemViewModel.presenter)
    });
  }
}
